import React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';

const StyledButton = styled(Button)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
  borderRadius: 10,
  padding: '10px 24px',
  color: '#fff',
  fontWeight: 600,
  textTransform: 'none',
  transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
  boxShadow: `0 4px 14px ${alpha(theme.palette.primary.main, 0.3)}`,
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: `0 8px 25px ${alpha(theme.palette.primary.main, 0.4)}`,
  },
  '&:active': { transform: 'translateY(0)' },
}));

export const ButtonWithEffects = ({ children, ...props }) => (
  <StyledButton {...props}>{children}</StyledButton>
);
